import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from 'jwt-decode';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginSuccess, setUnreadNotificationCount } from "../redux/actions/authActions";
import {
  extractAuthFromLoginResponse,
  fetchData,
  postRequest,
} from "../hooks/services/services";
import { showToast } from "../utils/toast";

const LoginWithGoogle = ({loginTypeValue}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const { email, name, sub: google_id } = decoded;

      // Optional: send to backend to register/login user
      const payload = {
        email,
        // google_id,
        name,
        type: loginTypeValue, 
        social_type: 'google',
      };

      const response = await postRequest("api/v1/sessions/social_login", payload);
      if (response.status === 200) {
        const responseData = await response.json();
        const { token, id } = extractAuthFromLoginResponse(response, responseData);

        if (!token) {
          throw new Error("Login succeeded but auth token was not received.");
        }

        const newUser = responseData?.new_user;
        const profileCompleted = responseData?.data?.profile_completed;

        dispatch(
          loginSuccess({
            token,
            id,
            user_type: payload.type,
            profile_completed: profileCompleted,
          })
        );

        if (payload.type === "Contractor") {
          if (!profileCompleted && newUser) {
            navigate("/buildyourprofile", {
              state: {
                userType: payload.type,
                email: payload.email,
                isGoogleLogin: true,
              },
            });
          } else if (!profileCompleted && !newUser) {
            navigate("/plan");
          } else if (profileCompleted && !newUser) {
            navigate("/contractor/profile");
          }
        } else if (payload.type === "Athlete") {
          if (!profileCompleted) {
            navigate("/profile");
          } else {
            navigate("/athlete/myroadmap");
          }
        } else {
          navigate("/business/info");
        }

        showToast(responseData?.message || "Logged in successfully!", "success");

        try {
          const notifRes = await fetchData("api/v1/notifications/unread_count");
          if (notifRes) {
            const notifData = await notifRes.json();
            dispatch(setUnreadNotificationCount(notifData?.unread_count || 0));
          }
        } catch (notifError) {
          console.warn("Failed to fetch unread notification count:", notifError);
        }
      }
    } catch (error) {
      console.error("Google login error:", error);
      showToast(error?.message || "Google login failed", "error");
    }
  };

  return (
    <GoogleLogin
      onSuccess={handleGoogleSuccess}
      onError={() => showToast("Google login failed", "error")}
    />
  );
};

export default LoginWithGoogle;
